export default {
  SET_LISTA_PRODUTOS(state, payload) {
    state.listaProdutos = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_PRODUTO(state, payload) {
    state.produtoCSV = payload;
  },
};
